import React from "react";
import IconButton from "@mui/material/IconButton";
import HelpIcon from '@mui/icons-material/Help';
import Box from "@mui/material/Box";
import { Popover, SxProps, Theme, Typography, Button} from "@mui/material";
import { translationService } from "../../services/translation/TranslationService";
import { observer } from "mobx-react-lite";

interface LabelingInfoProps {
  type: any;
  clickType?: 'icon' | 'button';
  iconSx?: SxProps<Theme>;
}

const LabelingInfo: React.FC<LabelingInfoProps> = observer(({ type, clickType, iconSx }) => {
  const InfoImages: Record<LabelingInfoProps['type'], { images: string[], desc: string, details: string | undefined}> = {
  main: {
    desc: translationService.translate("ocrService.dialogContent.howToMainInfo.desc"),
    details: undefined,
    images: ["images/How-to-Mark-MainInfo-Dialog.gif"],
  },
  detections: {
    desc: translationService.translate("ocrService.dialogContent.howToDetections.desc"),
    details: translationService.translate("ocrService.dialogContent.howToDetections.details"),
    images: ["images/How-to-Mark-Detections-Dialog.gif", "images/How-to-Mark-Distance-Dialog.gif", "images/Detections-Problem-1.png", "images/Detections-Problem-2.png"],
  },
  flow: {
    desc: translationService.translate("ocrService.dialogContent.howToStartLabeling.desc"),
    details: undefined,
    images: ["images/How-to-Open-MainInfo.gif", "images/How-to-Open-Detections-Distance.gif"]
  }
  };
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const info = InfoImages[type];

  if (!info) return null;

  return (
    <>
    {clickType === 'button' ? (
      <Button variant= "contained" color="error" size = "small" onClick={handleClick} sx= {{...iconSx}}>
      {translationService.translate('ocrService.dialogContent.howToStartLabeling.button')}
      </Button>
    ) : (
      <IconButton sx = {{color: "primary.main"}} onClick={handleClick}>
        <HelpIcon />
      </IconButton>
    )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box display="flex" flexDirection="column" justifyContent="center" p={2} sx={{ maxWidth: 400, width: '100%' }}>
          <Typography variant="body2" sx={{ m: 2, color: "blue" }}>{info.desc}</Typography>
          <Box sx = {{display: "flex", gap: 1, flexWrap: "wrap", flexDirection: "column", justifyContent: "center"}}>
            {info.images.map((image, index) => (
              <React.Fragment key={index}>
              <img
                key={index}
                src={image}
                style = {{width: 400, height: 250, objectFit: "contain", border: "1px solid #ccc", borderRadius: 10}}
              />
              {index === 1 && (
                <Typography variant = "body2" sx = {{m: 2, color: "red", fontWeight: "bold"}}>{info.details}</Typography>
              )}
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </Popover>
    </>
  );
});

export default LabelingInfo;
